export default {
  widgets: {
    analyticsPopularItems: {
      title: 'Ommabop maxsulotlar',
      select: {
        labels: {
          source: 'Manba',
          month: 'Oy',
          year: 'Yil',
          limit: 'Jadvaldagi soni:',
        },
        options: {
          loading: 'Yuklanmoqda...',
          all: 'Barchasi',
          months: [
            '',
            'Yanvar',
            'Fevral',
            'Mart',
            'Aprel',
            'May',
            'Iyun',
            'Iyul',
            'Avgust',
            'Sentabr',
            'Oktabr',
            'Noyabr',
            'Dekabr',
          ],
        },
        titles: {
          choose: 'Qiymatni tanlang',
        },
      },
      table: {
        headers: {
          titles: {
            items: 'Tovar',
            sales: 'Sotuvlar',
            salesSum: 'Savdo summasi',
            price: 'Narxi',
          },
        },
      },
      tabs: {
        monthly: 'Oyiga',
        yearly: 'Yiliga',
      },
    },
  },
};
